(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anam-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anam-collection-description')) {
  customElements.define('anam-collection-description', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.content = this.querySelector('.anam-description__content');
      this.button = this.querySelector('button');
      this.expanded = false;
      this.button.addEventListener('click', () => this.setExpanded(!this.expanded));
      this.content.addEventListener('click', (event) => {
        if (this.hasAttribute('data-collapsed') && !event.target.closest('a, button, input, select, textarea') && !window.getSelection().toString()) this.setExpanded(true);
      });
      this.content.addEventListener('focusin', () => this.setExpanded(true));
      this.content.addEventListener('load', () => this.measure(), true);
      this.observer = new ResizeObserver(() => {
        if (this.width !== this.content.clientWidth) { this.width = this.content.clientWidth; this.measure(); }
      });
      this.observer.observe(this.content);
      this.measure();
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
    measure() {
      const origin = this.content.getBoundingClientRect().top;
      const lines = [];
      const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
      const range = document.createRange();
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.textContent.trim()) continue;
        range.selectNodeContents(node);
        for (const rect of range.getClientRects()) {
          if (!rect.width || !rect.height) continue;
          let line = lines.find(item => Math.abs(item.top - rect.top) < rect.height * .45);
          if (!line) { line = { top: rect.top, bottom: rect.bottom }; lines.push(line); }
          else line.bottom = Math.max(line.bottom, rect.bottom);
        }
      }
      lines.sort((a, b) => a.top - b.top);
      const overflow = lines.length > 5;
      this.toggleAttribute('data-overflow', overflow);
      this.button.hidden = !overflow;
      if (overflow) {
        const fifth = lines[4];
        this.style.setProperty('--anam-cutoff', (fifth.bottom - origin + 2) + 'px');
        this.style.setProperty('--anam-fade-start', ((fifth.top + fifth.bottom) / 2 - origin) + 'px');
        this.style.setProperty('--anam-full', this.content.scrollHeight + 'px');
      }
      this.toggleAttribute('data-collapsed', overflow && !this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
    }
    setExpanded(value) {
      this.expanded = value;
      this.button.textContent = value ? this.dataset.less : this.dataset.more;
      this.measure();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anam-header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener("change", (event) => {
  if (event.target.id !== "Anam-Header-Category" || !event.target.value) return;
  window.location.assign(event.target.value);
});
  } catch(e) { console.error(e); }
})();

})();
